import { addModulePrefix as p } from "../helpers"

// Signal actions for Sagas (do not change the store)
export const REQUEST_PERMISSIONS = p(`REQUEST_PERMISSIONS`)
export const REQUEST_USER = p(`REQUEST_USER`)

// Actions for reducer (change store)
export const LOAD_PERMISSIONS_STARTED = p(`LOAD_PERMISSIONS_STARTED`)
export const LOAD_PERMISSIONS_COMPLETED = p(`LOAD_PERMISSIONS_COMPLETED`)
export const LOAD_PERMISSIONS_FAILED = p(`LOAD_PERMISSIONS_FAILED`)

export const LOAD_USER_STARTED = p(`LOAD_USER_STARTED`)
export const LOAD_USER_COMPLETED = p(`LOAD_USER_COMPLETED`)
export const LOAD_USER_FAILED = p(`LOAD_USER_FAILED`)
